import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

/**
 * Admin Forgot Password Page - mirrors Login.jsx styling.
 */
export default function ForgotPassword() {
    const { requestPasswordReset } = useAuth()
    const [email, setEmail] = useState('')
    const [submitted, setSubmitted] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')

    const handleSubmit = async (e) => {
        e.preventDefault()
        setError('')
        setLoading(true)

        try {
            await requestPasswordReset(email)
            setSubmitted(true)
        } catch (err) {
            setError(err.message || 'Failed to send reset email. Please try again.')
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4">
            <div className="w-full max-w-sm bg-white rounded-xl shadow-lg border border-slate-200 overflow-hidden">
                <div className="p-8 text-center bg-brand-navy border-b border-brand-navy-dark">
                    <img src="/logo.png" alt="TenderCentriX" className="h-10 mx-auto mb-4" />
                    <h1 className="text-lg font-bold text-white">Forgot password?</h1>
                    <p className="text-sm text-slate-300 mt-1">
                        {submitted
                            ? 'Check your inbox for reset instructions.'
                            : "Enter your admin email and we'll send you reset instructions."}
                    </p>
                </div>

                {submitted ? (
                    <div className="p-8 space-y-5 text-center">
                        <p className="text-sm text-slate-600">
                            If <strong>{email}</strong> is a registered admin account, a password reset link has been sent.
                        </p>
                        <Link
                            to="/login"
                            className="inline-flex justify-center w-full py-2.5 px-4 border border-transparent rounded-lg shadow-sm text-sm font-bold text-white bg-gradient-to-r from-[#a91e2d] to-[#d43f52] hover:bg-gradient-to-l transition-all"
                        >
                            Back to login
                        </Link>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="p-8 space-y-5">
                        {error && (
                            <div className="p-3 bg-red-50 text-red-600 text-sm rounded border border-red-100">
                                {error}
                            </div>
                        )}

                        <div>
                            <label className="block text-sm font-medium text-slate-700 mb-1">Email</label>
                            <input
                                type="email"
                                required
                                className="w-full px-4 py-3 text-sm font-medium border text-slate-900 truncate rounded-lg focus:border-brand-navy focus:ring-1 focus:ring-brand-navy outline-none placeholder:text-slate-400 shadow-sm"
                                placeholder="admin@company.com"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full flex justify-center py-2.5 px-4 border border-transparent rounded-lg shadow-sm text-sm font-bold text-white bg-gradient-to-r from-[#a91e2d] to-[#d43f52] hover:bg-gradient-to-l focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#a91e2d] disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                        >
                            {loading ? 'Sending...' : 'Send reset instructions'}
                        </button>

                        <div className="text-center">
                            <Link to="/login" className="text-xs text-slate-400 hover:text-slate-600">Back to login</Link>
                        </div>
                    </form>
                )}

                <div className="bg-slate-50 p-4 text-center border-t border-slate-100">
                    <p className="text-xs text-slate-400">© 2026 TenderCentriX. Secure Logged Access.</p>
                </div>
            </div>
        </div>
    )
}
